import { WIZ_BOOLEAN } from './../models/enums';

export class WizBooleanUtils {
  public static nextValue(pValue: WIZ_BOOLEAN): WIZ_BOOLEAN {
    switch (pValue) {
      case WIZ_BOOLEAN.UNKNOWN:
        return WIZ_BOOLEAN.FALSE;
      case WIZ_BOOLEAN.TRUE:
        return WIZ_BOOLEAN.UNKNOWN;
      default:
        return WIZ_BOOLEAN.TRUE;
    }
  }

  /**
   * conversion d'un string en Boolean. Prise en compte du null.
   */
  public static stringToBoolean(value: string): WIZ_BOOLEAN {
    return value === null || value === undefined ? WIZ_BOOLEAN.UNKNOWN : (value as WIZ_BOOLEAN);
  }

  /**
   * conversion d'un string en Boolean. Prise en compte du null.
   */
  public static stringToPureBoolean(value: string): WIZ_BOOLEAN {
    return value === null || value === undefined ? WIZ_BOOLEAN.FALSE : (value as WIZ_BOOLEAN);
  }
}
